export const API_config = {
    apiUrl: 'https://admin.monitgps.pl/api',
    username: 'api@api.pl',
    password: 'api123',
    get authHeader() {
        return `Basic ${btoa(`${this.username}:${this.password}`)}`;
    },
    bearerToken: 'T82dwS93iwo48Gbcv71z6vYZOvLAKwarHqzMKIq6lUI0RaQEDzHQ5PzdFkQIfWpQ',
    get bearerAuthHeader() {
        return `Bearer ${this.bearerToken}`;
    },
    baseApiUrl: 'https://api.monitgps.pl',
    get dataApiUrl() {
        return `${this.baseApiUrl}/stages.php`;
    },
    get messagesApiUrl() {
        return `${this.baseApiUrl}/simmessages.php`;
    },
    get twilioMessagesApiUrl() {
        return `${this.baseApiUrl}/twilio_messages.php`;
    },
    get recceApiUrl() {
        return `${this.baseApiUrl}/recceapi.php`;
    },
    get entryListApiUrl() {
        return `${this.baseApiUrl}/entry_list.php`;
    },
    get traccarManagerApiUrl() {
        return `${this.baseApiUrl}/traccar_device_manager.php`;
    },
    get safetyPointsApiUrl() {
        return `${this.baseApiUrl}/safety_points.php`;
    }
};
